import React from 'react';

/**
 * WheelsTable - Table view component for Wheels page
 * Displays wheels in a table format with columns for wheel details
 */
const WheelsTable = ({
  wheels,
  onViewWheel,
  onEditWheel,
  formatDate
}) => {
  return (
    <div className="wheels-table-container">
      <table className="wheels-table">
        <thead>
          <tr>
            <th>Wheel #</th>
            <th>Customer</th>
            <th>Contents</th>
            <th>Lot #</th>
            <th>Items</th>
            <th>Total Weight</th>
            <th>Created</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          {wheels.map((wheel) => (
            <tr key={wheel.id}>
              <td className="wheel-number">
                <span className="clickable-link" onClick={() => onViewWheel(wheel)}>
                  {wheel.wheel_number}
                </span>
                {wheel.is_full && (
                  <span className="full-badge">FULL</span>
                )}
                {wheel.label_text && (
                  <span className={`wheel-label-badge ${wheel.label_color || 'gray'}`}>
                    {wheel.label_text}
                  </span>
                )}
              </td>
              <td>{wheel.customer_name || '-'}</td>
              <td className="wheel-contents">
                <span className="items-preview">{wheel.item_names || '-'}</span>
              </td>
              <td>{wheel.all_lot_numbers || wheel.lot_number}</td>
              <td>{wheel.item_count} items</td>
              <td>{parseFloat(wheel.total_weight || 0).toFixed(2)} kg</td>
              <td>{formatDate(wheel.created_at)}</td>
              <td>
                <div style={{display: 'flex', gap: '6px'}}>
                  <button
                    className="action-btn view"
                    onClick={() => onViewWheel(wheel)}
                  >
                    View
                  </button>
                  <button
                    className="action-btn edit"
                    onClick={() => onEditWheel(wheel)}
                  >
                    Edit
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default WheelsTable;
